import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { KycInfo } from "../../../models/cartable.model";

interface Props {
  data: KycInfo;
}
const VideoAuthorization = ({ data }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleOpenImage = () => {
    const imageUrl = `${data?.nationalCardFront?.fileUrl!}/true`;

    if (!imageUrl) {
      alert("آدرس تصویر وجود ندارد.");
      return;
    }

    const newWindow = window.open("", "_blank");
    if (!newWindow) {
      alert("پنجره جدید توسط مرورگر مسدود شده است.");
      return;
    }

    const htmlContent = `
    <!DOCTYPE html>
    <html lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>نمایش تصویر</title>
      <style>
      @font-face {
      font-family: "iranSansMedium";
      src: url("/fonts/IRANSansBold.ttf");
      }
      html, body {
      height: 100%;
      margin: 0;
      padding: 0;
      }
      body {
      background-color: #fff;
      margin: 0;
      font-family: "iranSansMedium";
      min-height: 100vh;
      min-width: 100vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      }
      .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 20vh;
      flex: 1;
      overflow: hidden;
      }
      img {
      max-width: 90vw;
      max-height: 80vh;
      min-width: 40%;
      min-height: 40%;
      transition: transform 0.3s ease, width 0.3s, height 0.3s;
      border: 1px solid #ddd;
      display: block;
      margin: 0 auto;
      object-fit: contain;
      cursor: default;
      }
      img.zoom-cursor {
      cursor: zoom-in;
      }
      img.zoomed {
      cursor: zoom-out;
      z-index: 10;
      }
      .buttons {
      margin-top: 20px;
      position: static;
      text-align: center;
      }
      button {
      height: 5vh;
      background-color: #3498db;
      color: white;
      border: none;
      padding: 7px 20px;
      margin: 0 10px;
      font-size: 15px;
      cursor: pointer;
      border-radius: 5px;
      font-family: "iranSansMedium";
      display: inline-flex;
      align-items: center;
      gap: 5px;
      }
      button .icon {
      font-family: "iranSansMedium";
      font-size: 1.3rem;
      vertical-align: middle;
      position: relative;
      top: 3px;
      }
      button:hover {
      background-color: #2980b9;
      }
      </style>
    </head>
    <body>
      <div class="image-container">
      <img id="rotatableImage" src="${imageUrl}" alt="تصویر" />
      </div>
      <div class="buttons">
      <button onclick="rotate(-90)"><span class="icon">⟲</span> چرخش به چپ</button>
      <button onclick="rotate(90)">چرخش به راست <span class="icon">⟳</span></button>
      </div>
      <script>
      let angle = 0;
      let scale = 1;
      function rotate(deg) {
      angle = (angle + deg) % 360;
      updateTransform();
      // Adaptive resizing for 90/270 degrees
      const img = document.getElementById("rotatableImage");
      if (Math.abs(angle % 180) === 90) {
        img.style.maxWidth = "80vh";
        img.style.maxHeight = "90vw";
      } else {
        img.style.maxWidth = "90vw";
        img.style.maxHeight = "80vh";
      }
      }
      function updateTransform() {
      const img = document.getElementById("rotatableImage");
      img.style.transform = "rotate(" + angle + "deg) scale(" + scale + ")";
      }
      // Initial resize in case image is already rotated
      rotate(0);

      // Zoom on hover/click
      const img = document.getElementById("rotatableImage");
      img.classList.add('zoom-cursor');
      let zoomed = false;
      img.addEventListener('mouseenter', function() {
      img.classList.add('zoom-cursor');
      });
      img.addEventListener('mouseleave', function() {
      img.classList.remove('zoom-cursor');
      img.classList.remove('zoomed');
      scale = 1;
      updateTransform();
      zoomed = false;
      });
      img.addEventListener('click', function() {
      zoomed = !zoomed;
      if (zoomed) {
        scale = 2;
        img.classList.add('zoomed');
      } else {
        scale = 1;
        img.classList.remove('zoomed');
      }
      updateTransform();
      });
      </script>
    </body>
    </html>
    `;

    newWindow.document.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };
  return (
    <>
      <Grid
        container
        sx={{
          border: "2px solid #C1C7CB",
          borderRadius: "5px",
          width: "100%",
          height: "fit-content",
          padding: "2rem",
          position: "relative",
        }}
        flexDirection={isMobile ? "column" : "row"}
      >
        <Typography
          sx={{
            position: "absolute",
            top: "-12px",
            right: "30px",
            backgroundColor: "#fff",
            color: "#1D4A87",
            fontSize: "1.2rem",
            fontWeight: "bold",
            paddingInline: "5px",
          }}
        >
          احراز هویت ویدیویی
        </Typography>
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            borderLeft: isMobile ? "" : "2px solid #C1C7CB",
            padding: "1rem",
          }}
        >
          <Typography
            sx={{ color: "#34495E", fontSize: "1rem", fontWeight: "bold" }}
          >
            <span
              style={{
                color: "#9AAFC4",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              متن احراز هویت:
            </span>{" "}
            {data?.kycText}
          </Typography>
          <Box
            sx={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <video
              src={data?.kycVideoUrl}
              controlsList="nodownload"
              playsInline
              controls
              muted={false}
              className="VideoAuthorization-video"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4} sx={{ padding: "1rem" }}>
          <Grid container flexDirection={"column"} gap={"2rem"} height={"100%"}>
            {data?.nationalCardFront?.fileUrl && (
              <Grid item height={"50%"} width={"100%"}>
                <a
                  onClick={() => handleOpenImage()}
                  href={`${data?.nationalCardFront?.fileUrl!}/true`}
                  target="_blank"
                >
                  <img
                    className="VideoAuthorization-image"
                    src={data?.nationalCardFront?.fileUrl}
                    alt="تصویر روی کارت ملی"
                  />
                </a>
              </Grid>
            )}
            <Grid item>
              <Typography
                sx={{ color: "#34495e", fontSize: "1rem", fontWeight: "bold" }}
              >
                <span style={{ color: "#9AAFC4" }}>تاریخ ثبت:</span>{" "}
                {data?.kycDatePersian}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default VideoAuthorization;
